import { z } from "zod";
import { NeighborsSource } from "@models/enums/components/Neighbors/NeighborsSource.enum";

const nodeSchema = z.object({
  l: z.string(),
  r: z.string(),
});

export const NeighborsDataSchema = z.record(nodeSchema);

export const NeighborsSchema = z.object({
  enabled: z.boolean(),
  modeLr: z.boolean(),
  data: NeighborsDataSchema,
  source: z.nativeEnum(NeighborsSource).optional(),
});

